




























import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
} from '@vue/composition-api';
import Description from '@/components/Description/index.vue';
import { ArchiveInfo, BibliographyResponse } from '@oare/types';
import sl from '@/serviceLocator';

export default defineComponent({
  name: 'ArchiveInfo',
  components: {
    Description,
  },
  props: {
    archive: {
      type: Object as PropType<ArchiveInfo>,
      required: true,
    },
    showRouterLink: {
      type: Boolean,
      default: true,
    },
    allowCUD: {
      type: Boolean,
      default: false,
    },
  },
  setup({ archive }, { emit }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const store = sl.get('store');
    const loading = ref(false);
    const bibliography = ref('');

    const canViewBibliography = computed(() =>
      store.hasPermission('BIBLIOGRAPHY')
    );

    const refreshPage = () => {
      emit('refresh-page');
    };

    onMounted(async () => {
      if (archive.bibliographyUuid && canViewBibliography.value) {
        loading.value = true;
        try {
          const bibliographyResponse: BibliographyResponse = await server.getBibliography(
            archive.bibliographyUuid
          );
          bibliography.value = bibliographyResponse.bibliography.bib!!;
        } catch (err) {
          actions.showErrorSnackbar(
            'Unable to get bibliography information',
            err as Error
          );
        } finally {
          loading.value = false;
        }
      }
    });
    return {
      canViewBibliography,
      loading,
      bibliography,
      refreshPage,
    };
  },
});
